<ng-container *ngIf="activeMatches$ | async as matches; else placeholder">
  <div class="d-flex flex-column gap-2 p-3" *ngIf="matches.length > 0">
    <app-match-card [match]="match" *ngFor="let match of matches" [matchDocId]="match.matchDocId"></app-match-card>
  </div>
</ng-container>
<ng-template #placeholder>
  <div class="d-flex flex-column gap-2 p-3">
    <app-match-card-placeholder [default]="false"></app-match-card-placeholder>
  </div>
</ng-template>